<script setup>
  defineOptions({
    name: "ComponentExpandableBadge",
  });

  defineProps({
    short: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <div :class="{'cursor-help': short !== null}" class="group relative self-start">
    <span
      v-if="short !== null"
      class="inline-flex items-center rounded-md bg-red-50 px-1 py-0.5 text-xs font-medium whitespace-nowrap text-red-700 ring-1 ring-red-600/10 ring-inset group-hover:invisible"
      v-text="short"
    />

    <span
      class="inline-flex items-center rounded-md bg-red-50 px-1 py-0.5 text-xs font-medium whitespace-nowrap text-red-700 ring-1 ring-red-600/10 ring-inset"
      :class="{hidden: short !== null, 'absolute top-1 right-0 z-50 group-hover:block': short !== null}"
    >
      <slot></slot>
    </span>
  </div>
</template>
